import { render, staticRenderFns } from "./stocksake.vue?vue&type=template&id=247e22d4&scoped=true"
import script from "./stocksake.vue?vue&type=script&lang=js"
export * from "./stocksake.vue?vue&type=script&lang=js"
import style0 from "./stocksake.vue?vue&type=style&index=0&id=247e22d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247e22d4",
  null
  
)

export default component.exports